if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.galleryReady = false;
        this.currentIndex = 0;
        this.gestureStartX = 0;
        this.gestureStartY = 0;
        this.ignoreImageClickUntil = 0;
      }

      connectedCallback() {
        this.initializeGallery();
      }

      initializeGallery() {
        if (this.galleryReady) return;

        this.content = this.querySelector('.product-media-modal__content');
        this.items = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
        this.previousButton = this.querySelector('[data-novera-gallery-previous]');
        this.nextButton = this.querySelector('[data-novera-gallery-next]');
        this.counterCurrent = this.querySelector('[data-novera-gallery-current]');
        this.counterTotal = this.querySelector('[data-novera-gallery-total]');
        this.counter = this.querySelector('.novera-gallery-counter');
        this.hint = this.querySelector('.novera-gallery-hint');

        if (!this.content || !this.items.length) return;

        this.galleryReady = true;
        const hasMultipleItems = this.items.length > 1;
        [this.previousButton, this.nextButton, this.counter, this.hint].forEach((element) => {
          if (element) element.hidden = !hasMultipleItems;
        });

        if (this.counterTotal) this.counterTotal.textContent = this.items.length;

        this.previousButton?.addEventListener('click', () => this.showPreviousMedia());
        this.nextButton?.addEventListener('click', () => this.showNextMedia());
        this.addEventListener('keydown', (event) => this.onGalleryKeydown(event));
        this.content.addEventListener('click', (event) => this.onMediaClick(event));
        this.content.addEventListener('pointerdown', (event) => this.onGestureStart(event));
        this.content.addEventListener('pointerup', (event) => this.onGestureEnd(event));

        /* Dawn closes a media modal on any mouse pointer-up. Keep gallery controls
           and image clicks inside the modal, while the dedicated close button
           continues to work normally. */
        [this.content, this.previousButton, this.nextButton, this.counter, this.hint].forEach((element) => {
          element?.addEventListener('pointerup', (event) => event.stopPropagation());
        });
      }

      hide() {
        window.pauseAllMedia();
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.initializeGallery();
        this.showActiveMedia();
      }

      showActiveMedia() {
        const requestedMediaId = this.openedBy?.getAttribute('data-media-id');
        const requestedIndex = this.items.findIndex((item) => item.dataset.mediaId === requestedMediaId);
        this.activateMedia(requestedIndex >= 0 ? requestedIndex : 0);
      }

      activateMedia(index) {
        if (!this.items?.length) return;

        window.pauseAllMedia();
        this.currentIndex = (index + this.items.length) % this.items.length;

        this.items.forEach((item, itemIndex) => {
          const isActive = itemIndex === this.currentIndex;
          item.classList.toggle('active', isActive);
          item.hidden = !isActive;
          item.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        const activeMedia = this.items[this.currentIndex];
        if (this.counterCurrent) this.counterCurrent.textContent = this.currentIndex + 1;
        if (this.content) {
          this.content.scrollTop = 0;
          this.content.scrollLeft = 0;
        }

        const activeMediaTemplate = activeMedia.querySelector?.('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }

      showPreviousMedia() {
        this.activateMedia(this.currentIndex - 1);
      }

      showNextMedia() {
        this.activateMedia(this.currentIndex + 1);
      }

      onGalleryKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showPreviousMedia();
        }

        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showNextMedia();
        }
      }

      onMediaClick(event) {
        if (Date.now() < this.ignoreImageClickUntil) return;
        if (event.target.closest('img[data-media-id]') && this.items.length > 1) this.showNextMedia();
      }

      onGestureStart(event) {
        this.gestureStartX = event.clientX;
        this.gestureStartY = event.clientY;
      }

      onGestureEnd(event) {
        if (this.items.length < 2) return;

        const deltaX = event.clientX - this.gestureStartX;
        const deltaY = event.clientY - this.gestureStartY;

        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

        this.ignoreImageClickUntil = Date.now() + 450;
        if (deltaX < 0) this.showNextMedia();
        else this.showPreviousMedia();
      }
    }
  );
}
